import React, { Fragment } from 'react'
import Script from 'next/script'
import Env from 'Env'

const CjAffiliate = () => {
  return (
    <Fragment>
      <Script id="cj-tracking" strategy="afterInteractive">
        {`
        (async () => {
          const queryString = window.location.search
          const urlParams = new URLSearchParams(queryString)
          const cj_event = urlParams.get('cjevent')
          if(cj_event){
            const cj_aid = urlParams.get('AID') ?? ''
            const cj_pid = urlParams.get('PID') ?? ''

            let cookie_name = 'cje';
            let domain = '.' + window.location.hostname.split('.').slice(-2).join(".")
            // let domain = 'localhost';
            let expires = "expires="+ new Date(Date.now() + (86400 * 395 * 1000)).toUTCString();
            document.cookie = 'cje=' + cj_event + '; ' + expires +' ; path=/; domain=' +domain+ '; secure;'

            // Extra CJ Data
            document.cookie = 'cj_aid=' + cj_aid + '; ' + expires +' ; path=/; domain=' +domain+ '; secure;'
            document.cookie = 'cj_pid=' + cj_pid + '; ' + expires +' ; path=/; domain=' +domain+ '; secure;'
            
            // expire tapfillate
            document.cookie = "tap_ref=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + domain + ";";
            document.cookie = "tap_vid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + domain + ";";

            let cj_ref_data = cj_event + '-' + cj_aid + '-' + cj_pid;

            let witopia_url = document.getElementById('witopia_url').getElementsByTagName('a')[0];
            let currentLink = witopia_url.href;
            const elementParams = new URL(currentLink);
            const cj_ref_val = elementParams.searchParams.get('cjevent');
            const cj_aid_val = elementParams.searchParams.get('AID');
            const cj_pid_val = elementParams.searchParams.get('PID');

            if(elementParams.searchParams.get('ref')){
              elementParams.searchParams.delete('ref')
            }

            if (!cj_ref_val){
              elementParams.searchParams.append('cjevent', cj_event)
              elementParams.searchParams.append('AID', cj_aid)
              elementParams.searchParams.append('PID', cj_pid)
              witopia_url.href = elementParams.href
            }else{
              const replace_cj = currentLink.replace(cj_ref_val, cj_event)
              const replace_aid = replace_cj.replace(cj_aid_val, cj_aid)
              const final_url = replace_aid.replace(cj_pid_val, cj_pid)
              witopia_url.href = final_url
            }
            
            const formData = new FormData();
            formData.append('referral_type', 'cj');
            formData.append('referral_code', 'cj');
            formData.append('landing_page', window.location.href);
            if (urlParams.get('utm_source')) {
                formData.append('source', urlParams.get('utm_source'));
            }
            formData.append('tracking_id', cj_ref_data);
            
            await fetch('${Env.SmeApiTrackingEndpoint}', {
              method: 'POST',
              body: formData
            }).then(() => {}).catch((err) => {
                console.log('conversion tracking cj error', err)
            });
          }
        })();
      `}
      </Script>
    </Fragment>
  )
}

export default CjAffiliate
